// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.side-modal-backdrop {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 1040;
  cursor: pointer;
  animation: fadeIn 0.2s ease-out;
}

.side-modal-panel {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  background-color: #fff;
  z-index: 1050;
  display: flex;
  flex-direction: column;
  box-shadow: -4px 0 25px rgba(0, 0, 0, 0.15);
  animation: slideInRight 0.3s ease-out;
}
.side-modal-panel.side-modal-sm {
  width: 380px;
}
.side-modal-panel.side-modal-md {
  width: 500px;
}
.side-modal-panel.side-modal-lg {
  width: 640px;
}
.side-modal-panel.side-modal-xl {
  width: 850px;
}
.side-modal-panel.side-modal-fullscreen {
  width: 100%;
  max-width: 100%;
  box-shadow: none;
}
.side-modal-panel.side-modal-expanded {
  width: calc(100% - var(--vz-sidebar-width, 250px));
  max-width: calc(100% - var(--vz-sidebar-width, 250px));
}
@media (max-width: 576px) {
  .side-modal-panel {
    width: 100% !important;
  }
}

.side-modal-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 1rem 1.25rem;
  border-bottom: 1px solid #e9ebec;
  background-color: #f3f6f9;
  flex-shrink: 0;
}
@media (max-width: 576px) {
  .side-modal-header {
    padding-top: calc(1rem + env(safe-area-inset-top, 0));
  }
}

.side-modal-title {
  margin: 0;
  font-size: 1rem;
  font-weight: 600;
  color: #495057;
}

.side-modal-header-actions {
  display: flex;
  align-items: center;
  gap: 0.5rem;
}

.side-modal-expand-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  padding: 0;
  border: none;
  background: transparent;
  border-radius: 4px;
  color: #878a99;
  font-size: 1.1rem;
  cursor: pointer;
  transition: all 0.15s ease;
}
.side-modal-expand-btn:hover {
  background-color: rgba(0, 0, 0, 0.05);
  color: #405189;
}

.side-modal-close {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  padding: 0;
  border: none;
  background: transparent;
  border-radius: 4px;
  color: #878a99;
  font-size: 1.25rem;
  cursor: pointer;
  transition: all 0.15s ease;
}
.side-modal-close:hover {
  background-color: rgba(0, 0, 0, 0.05);
  color: #405189;
}

.side-modal-body {
  flex: 1 1;
  padding: 1.25rem;
  padding-bottom: 0;
  overflow-y: auto;
  overflow-x: hidden;
  display: flex;
  flex-direction: column;
}
.side-modal-body > form {
  display: flex;
  flex-direction: column;
  flex: 1 1;
  min-height: 0;
}
.side-modal-body .form-actions {
  position: sticky;
  bottom: 0;
  display: flex;
  justify-content: flex-end;
  gap: 0.75rem;
  padding: 1rem 0;
  margin-top: auto;
  background-color: #fff;
  border-top: 1px solid #e9ebec;
  z-index: 10;
}
.side-modal-body .form-actions::before {
  content: "";
  position: absolute;
  top: -10px;
  left: 0;
  right: 0;
  height: 10px;
  background: linear-gradient(to top, rgba(255, 255, 255, 0.9), transparent);
  pointer-events: none;
}
.side-modal-body::-webkit-scrollbar {
  width: 5px;
}
.side-modal-body::-webkit-scrollbar-track {
  background: #f1f1f1;
}
.side-modal-body::-webkit-scrollbar-thumb {
  background: #c1c1c1;
  border-radius: 3px;
}
.side-modal-body::-webkit-scrollbar-thumb:hover {
  background: #a1a1a1;
}

@media (max-width: 576px) {
  .side-modal-body .form-actions {
    flex-direction: column-reverse;
    gap: 0.5rem;
    padding: 1rem 0;
    padding-bottom: calc(1rem + env(safe-area-inset-bottom, 0));
  }
  .side-modal-body .form-actions .btn {
    width: 100%;
  }
}
.side-modal-footer {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 0.5rem;
  padding: 1rem 1.25rem;
  padding-bottom: calc(1rem + env(safe-area-inset-bottom, 0));
  border-top: 1px solid #e9ebec;
  background-color: #f3f6f9;
  flex-shrink: 0;
}

@keyframes fadeIn {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}
@keyframes slideInRight {
  from {
    transform: translateX(100%);
  }
  to {
    transform: translateX(0);
  }
}`, "",{"version":3,"sources":["webpack://./src/components/Common/SideModal.scss"],"names":[],"mappings":"AAGA;EACE,eAAA;EACA,MAAA;EACA,OAAA;EACA,QAAA;EACA,SAAA;EACA,oCAAA;EACA,aAAA;EACA,eAAA;EACA,+BAAA;AAFF;;AAMA;EACE,eAAA;EACA,MAAA;EACA,QAAA;EACA,SAAA;EACA,sBAAA;EACA,aAAA;EACA,aAAA;EACA,sBAAA;EACA,2CAAA;EACA,qCAAA;AAHF;AAME;EACE,YAAA;AAJJ;AAOE;EACE,YAAA;AALJ;AAQE;EACE,YAAA;AANJ;AASE;EACE,YAAA;AAPJ;AAUE;EACE,WAAA;EACA,eAAA;EACA,gBAAA;AARJ;AAYE;EACE,kDAAA;EACA,sDAAA;AAVJ;AAcE;EA1CF;IA2CI,sBAAA;EAXF;AACF;;AAeA;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,qBAAA;EACA,gCAAA;EACA,yBAAA;EACA,cAAA;AAZF;AAcE;EATF;IAUI,qDAAA;EAXF;AACF;;AAcA;EACE,SAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;AAXF;;AAcA;EACE,aAAA;EACA,mBAAA;EACA,WAAA;AAXF;;AAcA;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;EACA,YAAA;EACA,UAAA;EACA,YAAA;EACA,uBAAA;EACA,kBAAA;EACA,cAAA;EACA,iBAAA;EACA,eAAA;EACA,0BAAA;AAXF;AAaE;EACE,qCAAA;EACA,cAAA;AAXJ;;AAeA;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;EACA,YAAA;EACA,UAAA;EACA,YAAA;EACA,uBAAA;EACA,kBAAA;EACA,cAAA;EACA,kBAAA;EACA,eAAA;EACA,0BAAA;AAZF;AAcE;EACE,qCAAA;EACA,cAAA;AAZJ;;AAiBA;EACE,SAAA;EACA,gBAAA;EACA,iBAAA;EACA,gBAAA;EACA,kBAAA;EACA,aAAA;EACA,sBAAA;AAdF;AAiBE;EACE,aAAA;EACA,sBAAA;EACA,SAAA;EACA,aAAA;AAfJ;AAmBE;EACE,gBAAA;EACA,SAAA;EACA,aAAA;EACA,yBAAA;EACA,YAAA;EACA,eAAA;EACA,gBAAA;EACA,sBAAA;EACA,6BAAA;EACA,WAAA;AAjBJ;AAoBI;EACE,WAAA;EACA,kBAAA;EACA,UAAA;EACA,OAAA;EACA,QAAA;EACA,YAAA;EACA,0EAAA;EACA,oBAAA;AAlBN;AAuBE;EACE,UAAA;AArBJ;AAwBE;EACE,mBAAA;AAtBJ;AAyBE;EACE,mBAAA;EACA,kBAAA;AAvBJ;AAyBI;EACE,mBAAA;AAvBN;;AA6BA;EACE;IACE,8BAAA;IACA,WAAA;IACA,eAAA;IACA,2DAAA;EA1BF;EA4BE;IACE,WAAA;EA1BJ;AACF;AA+BA;EACE,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,WAAA;EACA,qBAAA;EACA,2DAAA;EACA,6BAAA;EACA,yBAAA;EACA,cAAA;AA7BF;;AAiCA;EACE;IACE,UAAA;EA9BF;EAgCA;IACE,UAAA;EA9BF;AACF;AAiCA;EACE;IACE,2BAAA;EA/BF;EAiCA;IACE,wBAAA;EA/BF;AACF","sourcesContent":["// SideModal - Soldan açılan modal component\n\n// Backdrop - karanlık arkaplan\n.side-modal-backdrop {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background-color: rgba(0, 0, 0, 0.5);\n  z-index: 1040;\n  cursor: pointer;\n  animation: fadeIn 0.2s ease-out;\n}\n\n// Modal Panel - sağdan kayan panel\n.side-modal-panel {\n  position: fixed;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  background-color: #fff;\n  z-index: 1050;\n  display: flex;\n  flex-direction: column;\n  box-shadow: -4px 0 25px rgba(0, 0, 0, 0.15);\n  animation: slideInRight 0.3s ease-out;\n\n  // Size variants\n  &.side-modal-sm {\n    width: 380px;\n  }\n\n  &.side-modal-md {\n    width: 500px;\n  }\n\n  &.side-modal-lg {\n    width: 640px;\n  }\n\n  &.side-modal-xl {\n    width: 850px;\n  }\n\n  &.side-modal-fullscreen {\n    width: 100%;\n    max-width: 100%;\n    box-shadow: none;\n  }\n\n  // Sidebar'a kadar genişler (sidebar genişliği hariç)\n  &.side-modal-expanded {\n    width: calc(100% - var(--vz-sidebar-width, 250px));\n    max-width: calc(100% - var(--vz-sidebar-width, 250px));\n  }\n\n  // Mobile responsive\n  @media (max-width: 576px) {\n    width: 100% !important;\n  }\n}\n\n// Header\n.side-modal-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 1rem 1.25rem;\n  border-bottom: 1px solid #e9ebec;\n  background-color: #f3f6f9;\n  flex-shrink: 0;\n\n  @media (max-width: 576px) {\n    padding-top: calc(1rem + env(safe-area-inset-top, 0));\n  }\n}\n\n.side-modal-title {\n  margin: 0;\n  font-size: 1rem;\n  font-weight: 600;\n  color: #495057;\n}\n\n.side-modal-header-actions {\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n}\n\n.side-modal-expand-btn {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 32px;\n  height: 32px;\n  padding: 0;\n  border: none;\n  background: transparent;\n  border-radius: 4px;\n  color: #878a99;\n  font-size: 1.1rem;\n  cursor: pointer;\n  transition: all 0.15s ease;\n\n  &:hover {\n    background-color: rgba(0, 0, 0, 0.05);\n    color: #405189;\n  }\n}\n\n.side-modal-close {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 32px;\n  height: 32px;\n  padding: 0;\n  border: none;\n  background: transparent;\n  border-radius: 4px;\n  color: #878a99;\n  font-size: 1.25rem;\n  cursor: pointer;\n  transition: all 0.15s ease;\n\n  &:hover {\n    background-color: rgba(0, 0, 0, 0.05);\n    color: #405189;\n  }\n}\n\n// Body - scrollable content area\n.side-modal-body {\n  flex: 1;\n  padding: 1.25rem;\n  padding-bottom: 0; // Remove bottom padding, form-actions will handle it\n  overflow-y: auto;\n  overflow-x: hidden;\n  display: flex;\n  flex-direction: column;\n\n  // Forms inside modal should fill the space\n  > form {\n    display: flex;\n    flex-direction: column;\n    flex: 1;\n    min-height: 0; // Important for flex scrolling\n  }\n\n  // Form actions sticky at bottom\n  .form-actions {\n    position: sticky;\n    bottom: 0;\n    display: flex;\n    justify-content: flex-end;\n    gap: 0.75rem;\n    padding: 1rem 0;\n    margin-top: auto;\n    background-color: #fff;\n    border-top: 1px solid #e9ebec;\n    z-index: 10;\n\n    // Add shadow to indicate scrollable content above\n    &::before {\n      content: '';\n      position: absolute;\n      top: -10px;\n      left: 0;\n      right: 0;\n      height: 10px;\n      background: linear-gradient(to top, rgba(255,255,255,0.9), transparent);\n      pointer-events: none;\n    }\n  }\n\n  // Custom scrollbar\n  &::-webkit-scrollbar {\n    width: 5px;\n  }\n\n  &::-webkit-scrollbar-track {\n    background: #f1f1f1;\n  }\n\n  &::-webkit-scrollbar-thumb {\n    background: #c1c1c1;\n    border-radius: 3px;\n\n    &:hover {\n      background: #a1a1a1;\n    }\n  }\n}\n\n// Mobile adjustments for form-actions\n@media (max-width: 576px) {\n  .side-modal-body .form-actions {\n    flex-direction: column-reverse;\n    gap: 0.5rem;\n    padding: 1rem 0;\n    padding-bottom: calc(1rem + env(safe-area-inset-bottom, 0));\n\n    .btn {\n      width: 100%;\n    }\n  }\n}\n\n// Footer\n.side-modal-footer {\n  display: flex;\n  align-items: center;\n  justify-content: flex-end;\n  gap: 0.5rem;\n  padding: 1rem 1.25rem;\n  padding-bottom: calc(1rem + env(safe-area-inset-bottom, 0));\n  border-top: 1px solid #e9ebec;\n  background-color: #f3f6f9;\n  flex-shrink: 0;\n}\n\n// Animations\n@keyframes fadeIn {\n  from {\n    opacity: 0;\n  }\n  to {\n    opacity: 1;\n  }\n}\n\n@keyframes slideInRight {\n  from {\n    transform: translateX(100%);\n  }\n  to {\n    transform: translateX(0);\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
